export default function _import(path, filename = 'views') {
  if (process.env.NODE_ENV === 'production') {
    return () => import(`@/${filename}/${path}`)
  } else {
    return require(`@/${filename}/${path}`).default
  }
}
